import Vue from 'vue';
import _ from 'underscore';
import Affix from 'vue-affix';
Vue.use(Affix);

Vue.component('sidebar-scroll', {
    data: function() {
        return {
            cardStyles: {},
            readMore: false
        };
    },
    mounted() {
        const _this = this;
        this.$nextTick(function() {
            Vue.set(_this.cardStyles, 'width', _this.getWidth());
            window.addEventListener('resize', _.throttle(_this.setWidth, 300));
        });
    },

    methods: {
        getWidth: function() {
            const containerWidth = this.$refs.cardContainer.clientWidth + 'px';
            return containerWidth;
        },

        setWidth: function() {
            const width = this.getWidth();
            Vue.set(this.cardStyles, 'width', width);
        }
    }
});
